import { render } from "./SharingType.vue?vue&type=template&id=77ef9890"
import script from "./SharingType.vue?vue&type=script&lang=ts"
export * from "./SharingType.vue?vue&type=script&lang=ts"
script.render = render

export default script